/* ═══════════════════════════════════════════════════════════════
   LC MARKET — MADECA CREAM Landing JS
   Cursor · Scroll · Magnet · Reveal · Compare · Cart · FAQ · Tweaks
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ─── CUSTOM CURSOR ─── */
  const cursor = document.querySelector('.cursor');
  const dot = document.querySelector('.cursor-dot');
  if (cursor && dot && window.matchMedia('(hover: hover)').matches && window.innerWidth > 900) {
    document.documentElement.classList.add('has-custom-cursor');
    let mx = 0, my = 0, cx = 0, cy = 0;
    document.addEventListener('mousemove', (e) => {
      mx = e.clientX; my = e.clientY;
      dot.style.transform = `translate(${mx}px, ${my}px) translate(-50%, -50%)`;
    });
    function loop() {
      cx += (mx - cx) * 0.55;
      cy += (my - cy) * 0.55;
      cursor.style.transform = `translate(${cx}px, ${cy}px) translate(-50%, -50%)`;
      requestAnimationFrame(loop);
    }
    loop();

    document.querySelectorAll('a, button, .magnet, .compare__slider, [data-cursor]').forEach((el) => {
      const type = el.dataset.cursor || (el.classList.contains('compare__slider') ? 'drag' : (el.classList.contains('btn') || el.classList.contains('magnet') ? 'cta' : 'link'));
      el.addEventListener('mouseenter', () => cursor.classList.add('is-' + type));
      el.addEventListener('mouseleave', () => cursor.classList.remove('is-' + type));
    });
  }

  /* ─── SCROLL PROGRESS ─── */
  const progress = document.querySelector('.scroll-progress__bar');
  if (progress) {
    const onScroll = () => {
      const h = document.documentElement.scrollHeight - window.innerHeight;
      const p = h > 0 ? (window.scrollY / h) * 100 : 0;
      progress.style.width = p + '%';
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ─── HEADER scroll state ─── */
  const header = document.querySelector('.header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('is-scrolled', window.scrollY > 40);
    }, { passive: true });
  }

  /* ─── REVEAL on scroll ─── */
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) {
        e.target.classList.add('is-visible');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0, rootMargin: '0px' });
  document.querySelectorAll('.reveal, .split-line, .process__step').forEach((el) => io.observe(el));

  // Immediately reveal elements already in viewport on load
  requestAnimationFrame(() => {
    document.querySelectorAll('.reveal, .split-line, .process__step').forEach((el) => {
      const r = el.getBoundingClientRect();
      if (r.top < window.innerHeight + 10) el.classList.add('is-visible');
    });
  });

  /* ─── COUNT UP ─── */
  const countIO = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (!e.isIntersecting) return;
      const el = e.target;
      const target = parseFloat(el.dataset.count);
      const decimals = (el.dataset.count.split('.')[1] || '').length;
      const dur = 1600;
      const start = performance.now();
      function step(t) {
        const p = Math.min(1, (t - start) / dur);
        const eased = 1 - Math.pow(1 - p, 3);
        const v = (target * eased).toFixed(decimals);
        el.textContent = v;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
      countIO.unobserve(el);
    });
  }, { threshold: 0.4 });
  document.querySelectorAll('[data-count]').forEach((el) => countIO.observe(el));

  /* ─── MAGNETIC buttons ─── */
  document.querySelectorAll('.magnet').forEach((wrap) => {
    const target = wrap.querySelector('.btn') || wrap;
    wrap.addEventListener('mousemove', (e) => {
      const r = wrap.getBoundingClientRect();
      const x = (e.clientX - r.left - r.width / 2) * 0.25;
      const y = (e.clientY - r.top - r.height / 2) * 0.25;
      target.style.transform = `translate(${x}px, ${y}px)`;
    });
    wrap.addEventListener('mouseleave', () => {
      target.style.transform = '';
    });
  });

  /* ─── BEFORE / AFTER ─── */
  const slider = document.querySelector('.compare__slider');
  if (slider) {
    const after = slider.querySelector('.compare__after');
    const handle = slider.querySelector('.compare__handle');
    let dragging = false;
    function setPos(clientX) {
      const r = slider.getBoundingClientRect();
      let pct = ((clientX - r.left) / r.width) * 100;
      pct = Math.max(0, Math.min(100, pct));
      after.style.clipPath = `inset(0 0 0 ${pct}%)`;
      handle.style.left = pct + '%';
    }
    const start = (e) => { e.preventDefault(); dragging = true; setPos((e.touches ? e.touches[0] : e).clientX); };
    slider.addEventListener('dragstart', (e) => e.preventDefault());
    const move = (e) => { if (dragging) setPos((e.touches ? e.touches[0] : e).clientX); };
    const stop = () => { dragging = false; };
    slider.addEventListener('mousedown', start);
    window.addEventListener('mousemove', move);
    window.addEventListener('mouseup', stop);
    slider.addEventListener('touchstart', start, { passive: true });
    window.addEventListener('touchmove', move, { passive: true });
    window.addEventListener('touchend', stop);
  }

  /* ─── FAQ accordion ─── */
  document.querySelectorAll('.faq__item').forEach((item) => {
    const btn = item.querySelector('.faq__q');
    btn.addEventListener('click', () => {
      const open = item.classList.contains('is-open');
      document.querySelectorAll('.faq__item.is-open').forEach((el) => el.classList.remove('is-open'));
      if (!open) item.classList.add('is-open');
    });
  });

  /* ─── STICKY BUY ─── */
  const sticky = document.querySelector('.sticky-buy');
  const heroSec = document.querySelector('.hero');
  const finalSec = document.querySelector('.final');
  if (sticky && heroSec) {
    const checkSticky = () => {
      const heroBottom = heroSec.getBoundingClientRect().bottom;
      const finalTop = finalSec ? finalSec.getBoundingClientRect().top : Infinity;
      const should = heroBottom < 0 && finalTop > window.innerHeight * 0.5;
      sticky.classList.toggle('is-visible', should);
    };
    window.addEventListener('scroll', checkSticky, { passive: true });
    checkSticky();
  }

  /* ─── CART DRAWER ─── */
  const cart = {
    items: [],
    open: false,
    drawer: document.querySelector('.cart-drawer'),
    overlay: document.querySelector('.cart-overlay'),
    countEl: document.querySelector('.header__cart-count'),
  };
  function openCart() {
    cart.open = true;
    cart.drawer.classList.add('is-open');
    cart.overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    cart.open = false;
    cart.drawer.classList.remove('is-open');
    cart.overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  function renderCart() {
    const body = cart.drawer.querySelector('.cart-drawer__body');
    const totalEl = cart.drawer.querySelector('[data-cart-total]');
    if (cart.items.length === 0) {
      body.innerHTML = '<div class="cart-drawer__empty">Tu carrito está vacío.<br><span style="font-size:14px;font-style:normal;color:var(--ink-soft)">Empezá por darte un capricho 🌿</span></div>';
      totalEl.textContent = '$0';
      cart.countEl.textContent = '0';
      return;
    }
    body.innerHTML = cart.items.map((it, i) => `
      <div class="cart-item">
        <div class="cart-item__img"><img src="preview-assets/madeca-real-1.jpg" alt=""></div>
        <div>
          <div class="cart-item__name">${it.name}</div>
          <div class="cart-item__variant">${it.variant}</div>
          <div class="cart-item__qty">
            <button data-qty="-1" data-i="${i}">−</button>
            <span>${it.qty}</span>
            <button data-qty="1" data-i="${i}">+</button>
          </div>
          <button class="cart-item__remove" data-remove="${i}">Eliminar</button>
        </div>
        <div class="cart-item__price">$${(it.price * it.qty).toLocaleString('es-CO')}</div>
      </div>
    `).join('');
    const total = cart.items.reduce((s, it) => s + it.price * it.qty, 0);
    totalEl.textContent = '$' + total.toLocaleString('es-CO');
    cart.countEl.textContent = cart.items.reduce((s, it) => s + it.qty, 0);
    body.querySelectorAll('[data-qty]').forEach((b) => {
      b.addEventListener('click', () => {
        const i = +b.dataset.i;
        cart.items[i].qty += +b.dataset.qty;
        if (cart.items[i].qty <= 0) cart.items.splice(i, 1);
        renderCart();
      });
    });
    body.querySelectorAll('[data-remove]').forEach((b) => {
      b.addEventListener('click', () => {
        cart.items.splice(+b.dataset.remove, 1);
        renderCart();
      });
    });
  }
  function addToCart(name, price, variant) {
    const found = cart.items.find((i) => i.name === name && i.variant === variant);
    if (found) found.qty += 1;
    else cart.items.push({ name, price, variant, qty: 1 });
    renderCart();
    openCart();
  }
  document.querySelectorAll('[data-add-to-cart]').forEach((b) => {
    b.addEventListener('click', () => {
      addToCart('Madeca Cream 100ml', 89900, 'Frasco · 100ml');
    });
  });
  document.querySelectorAll('[data-open-cart]').forEach((b) => {
    b.addEventListener('click', openCart);
  });
  document.querySelectorAll('[data-close-cart]').forEach((b) => {
    b.addEventListener('click', closeCart);
  });
  // Sticky buy shake at certain scroll depth
  let didShake = false;
  window.addEventListener('scroll', () => {
    if (didShake || !sticky) return;
    if (window.scrollY > document.documentElement.scrollHeight * 0.55 && sticky.classList.contains('is-visible')) {
      sticky.classList.add('is-shake');
      didShake = true;
      setTimeout(() => sticky.classList.remove('is-shake'), 700);
    }
  }, { passive: true });
  renderCart();

  /* ─── NAV DRAWER ─── */
  const navDrawer = document.querySelector('.nav-drawer');
  const navOverlay = document.querySelector('.nav-overlay');
  function openNav() {
    navDrawer.classList.add('is-open');
    navOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeNav() {
    navDrawer.classList.remove('is-open');
    navOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  document.querySelectorAll('[data-open-nav]').forEach((b) => b.addEventListener('click', openNav));
  document.querySelectorAll('[data-close-nav]').forEach((b) => b.addEventListener('click', (e) => {
    closeNav();
    // smooth scroll to anchor if it's a link
    const href = b.getAttribute && b.getAttribute('href');
    if (href && href.startsWith('#')) {
      e.preventDefault();
      setTimeout(() => {
        const t = document.querySelector(href);
        if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 350);
    }
  }));

  /* ─── TWEAKS PANEL ─── */
  const tweaks = document.querySelector('.tweaks');
  const tweakToggle = document.querySelector('.tweaks-toggle');
  if (tweaks && tweakToggle) {
    tweakToggle.addEventListener('click', () => tweaks.classList.toggle('is-open'));
    tweaks.querySelector('.tweaks__close').addEventListener('click', () => tweaks.classList.remove('is-open'));
    tweaks.querySelectorAll('[data-tweak]').forEach((b) => {
      b.addEventListener('click', () => {
        const key = b.dataset.tweak;
        const val = b.dataset.value;
        document.documentElement.setAttribute('data-' + key, val);
        tweaks.querySelectorAll(`[data-tweak="${key}"]`).forEach((x) => x.classList.remove('is-active'));
        b.classList.add('is-active');
      });
    });
  }
})();
